/* eslint-disable */

import deepmerge from 'deepmerge';

const baseName = 'app.reddeadredemption.2019.02';
const defaultParameters = {
  level2: 1,
  chapter1: 'undefined',
  chapter2: 'undefined',
  chapter3: 'special',
  customVars: {
    site: {
      1: '[site]', // `platform`
      2: '[nos]', // `broadcaster`
      3: '[nosop3]', // `programma`
      4: '[portal]', // `level2 type`
      6: '[article]', // `eventtype`
      7: '[general]', // `mediatype`
      9: '[site]', // `omroep 2 - nos platform`
      10: '[special]', // `omroep 3 - systemtag`
    },
  },
};

export function trackPage(page) {
  const trackingData = {
    customVars: {
      site: {
        8: `[${page}]`, // `title`
      },
    },
    name: `${baseName}.${page}.open`,
  };

  const trackingParameters = deepmerge(defaultParameters, trackingData);
  tag.page.send(trackingParameters);
}

export function trackClick(click) {
  const trackingData = {
    name: `${baseName}.${click}.click`,
    type: 'action',
  };

  const trackingParameters = deepmerge(defaultParameters, trackingData);
  tag.click.send(trackingParameters);
}



// WEBPACK FOOTER //
// ./src/utils/track.js